/*
 * View for the head of a sortable List
 */

define([
  "marionette",
  "underscore",
  "jquery",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListHead/template/sortableListHeadTemplate.html",
  "modules/shared/sortableList/sortableListHead/template/textFilterTemplate.html",
  "modules/shared/sortableList/sortableListHead/template/numericFilterTemplate.html",
  "modules/shared/sortableList/sortableListHead/template/dateFilterTemplate.html",
  "modules/shared/sortableList/sortableListHead/template/longTextFilterTemplate.html",
], function (
  Marionette,
  _,
  $,
  Messenger,
  SortableListHeadTemplate,
  TextFilterTemplate,
  NumberFilterTemplate,
  DateFilterTemplate,
  LongTextFilterTemplate,
) {
  "use strict";

  const SortableListHeadView = {};

  SortableListHeadView.sortableListHeadItemView = Marionette.ItemView.extend({
    template: SortableListHeadTemplate,
    tagName: "th",
    initialize: function () {
      this.checked = false;
    },
    insertFilterMenu: function (collection) {
      let attr;
      let backboneAttr;
      let checkboxMap;
      let data;
      let filterValues;
      const header = this.model;
      let i;
      let keys;
      let menuHtml;
      const isFiltering = typeof header.filterFunction === "function";

      if (header.get("textField") || header.get("booleanField")) {
        const booleanField = header.get("booleanField");
        //load checkboxes for each text option
        //map stores all the values for this field, and the value is a boolean stating whether at least one
        // non-filtered model exists with that field value
        checkboxMap = {};
        attr = header.get("modelAttribute");
        backboneAttr = true;
        if (attr.startsWith("_thisObject.")) {
          attr = attr.slice("_thisObject.".length);
          backboneAttr = false;
        }
        collection.each(function (model) {
          let value;
          if (backboneAttr) {
            value = model.get(attr);
          } else {
            value = model[attr];
          }
          if (booleanField) {
            if (value) {
              value = $.t("common.yes");
            } else {
              value = $.t("common.no");
            }
          }
          if (value in checkboxMap) {
            checkboxMap[value] = checkboxMap[value] && model.filteredOut; //should be false if at least one model
            // with that value is not filtered out (is
            // visible)
          } else {
            checkboxMap[value] = model.filteredOut;
          }
        }, this);
        keys = _.keys(checkboxMap);
        filterValues = header.filter;
        if (!filterValues) {
          //filter is a map with keys = field values and values = true if selected in filter, false otherwise
          //create starting filter with everything selected
          filterValues = {};
          for (i = 0; i < keys.length; i++) {
            filterValues[keys[i]] = true;
          }
        }
        data = _.extend(
          { filter: isFiltering },
          { filterValues: filterValues },
          { keys: keys },
          { checkboxMap: checkboxMap },
        );
        menuHtml = _.template(TextFilterTemplate, data);
      } else if (header.get("commaSeparatedField")) {
        //load checkboxes for each text option
        //map stores all the values for this field, and the value is a boolean stating whether at least one
        // non-filtered model exists with that field value
        checkboxMap = {};
        attr = header.get("modelAttribute");
        backboneAttr = true;
        if (attr.startsWith("_thisObject.")) {
          attr = attr.slice("_thisObject.".length);
          backboneAttr = false;
        }
        collection.each(function (model) {
          let value;
          if (backboneAttr) {
            value = model.get(attr);
          } else {
            value = model[attr];
          }
          if (value !== null) {
            const values = value.split(",");
            for (let c = 0; c < values.length; c++) {
              const v = values[c];
              if (v in checkboxMap) {
                checkboxMap[v] = checkboxMap[v] && model.filteredOut; //should be false if at least one model with
                // that value is not filtered out (is visible)
              } else {
                checkboxMap[v] = model.filteredOut;
              }
            }
          }
        }, this);
        keys = _.keys(checkboxMap);
        filterValues = header.filter;
        if (!filterValues) {
          //filter is a map with keys = field values and values = true if selected in filter, false otherwise
          //create starting filter with everything not selected
          filterValues = {};
          keys = keys.sort();
          for (i = 0; i < keys.length; i++) {
            filterValues[keys[i]] = false;
          }
        }
        data = _.extend(
          { filter: isFiltering },
          { filterValues: filterValues },
          { keys: keys },
          { checkboxMap: checkboxMap },
        );
        menuHtml = _.template(TextFilterTemplate, data);
      } else if (header.get("dateField")) {
        data = _.extend({ filter: isFiltering, minimum: "", maximum: "" });
        if (header.filter) {
          data.minimum = Messenger.reqres.request("get:iso:dateUtc", header.filter.Minimum);
          data.maximum = Messenger.reqres.request("get:iso:dateUtc", header.filter.Maximum);
        }
        menuHtml = _.template(DateFilterTemplate, data);
      } else if (header.get("numericField")) {
        checkboxMap = {};
        attr = header.get("modelAttribute");
        backboneAttr = true;
        if (attr.startsWith("_thisObject.")) {
          attr = attr.slice("_thisObject.".length);
          backboneAttr = false;
        }

        let minimum = void 0;
        let maximum = void 0;

        collection.each(function (model) {
          if (!model.filteredOut) {
            let value;
            if (backboneAttr) {
              value = model.get(attr);
            } else {
              value = model[attr];
            }
            if (!minimum || value < minimum) {
              //override if no min or if number is less than current min
              minimum = value;
            }
            if (!maximum || value > maximum) {
              maximum = value;
            }
          }
        }, this);
        data = {};
        //reuse the currently selected range if it's been set
        if (header.filter) {
          data.minimum = header.filter.Minimum;
          data.maximum = header.filter.Maximum;
        } else {
          data.minimum = minimum;
          data.maximum = maximum;
        }
        menuHtml = _.template(NumberFilterTemplate, data);
      } else if (header.get("longTextField") || header.get("arrayField")) {
        //use long text search for array fields as well
        data = { filter: isFiltering, text: "" };
        //get current value of the search field, if available
        if (header.filter) {
          data.text = header.filter.text;
        }
        menuHtml = _.template(LongTextFilterTemplate, data);
      }
      //edit popover content
      const popover = this.$el.find("#filter");
      menuHtml = menuHtml.bind(popover, data);
      popover.data("popover").options.content = menuHtml;
      //popover.data('popover').options.placement = 'right';

      popover.popover("show");

      // check selectAll check-box if all the items in the list are selected.
      if (
        this.$el.find("input[type='checkbox']:not(#selectAll)").length ===
        this.$el.find("input[type='checkbox']:checked").length
      ) {
        $("form .reportFilterPopover #selectAll", this.$el).prop("checked", true);
      }

      this.$el.i18n();
      return popover;
    },
    onRender: function () {
      //set width of the column using jQuery, if width attribute is defined in the header object
      const header = this.model;
      let width = header.get("width");
      if (width) {
        //adjust the width as needed to account for hidden headers and/or a total width of over 100%
        if (this._isPercentage(width)) {
          width = this._adjustWidth(this._percentageToNumber(width));
          width = width + "%";
        }
        this.$el.width(width);
      }

      if (header.get("hidden")) {
        this.$el.hide();
      }
      if (header.get("filterable")) {
        //create popover
        this.$el.find("#filter").popover({
          trigger: "manual",
          placement: "bottom",
          html: true,
          title: function () {
            let html =
              "<strong>" +
              $.t("sortableList.filter.filter") +
              ":</strong> " +
              header.get("headerName");
            if (typeof header.filterFunction === "function") {
              html +=
                '<button class="btn btn-danger pull-right" id="clearFilter">' +
                $.t("sortableList.filter.reset") +
                "</button>";
            }
            return html;
          },
        });
        //prevent propagation
        this.$el.find("#filter").on("hidden", function (event) {
          event.stopPropagation();
        });
      }
    },
    events: {
      "click #checkbox": function () {
        //allow click event to propagate
        this.trigger("toggle:checkbox");
      },
      "click #selectAll": function (e) {
        const isChecked = $(e.target).prop("checked");
        $("form .reportFilterPopover input[type='checkbox']:not(#selectAll)", this.$el).each(
          function () {
            $(this).prop("checked", isChecked);
          },
        );
      },
    },
    triggers: {
      "click #headerDiv": "sort:header",
      "click #filter": "click:filter",
      "submit form": "set:filter",
      "click #cancelFilter": "cancel:filter",
      "click #clearFilter": "clear:filter",
    },
    //function to adjust the passed width to account for incorrect total widths over 100% and for columns which may be
    // hidden
    _adjustWidth: function (width) {
      //figures out what percentage of the table is hidden, and what value to give to the non-hidden parts of the table
      let hiddenWidth = 0;
      let nonHiddenWidth = 0;
      let nonHiddenCount = 0;
      this.model.collection.each(function (filter) {
        if (filter.get("width")) {
          if (filter.get("hidden")) {
            hiddenWidth += this._percentageToNumber(filter.get("width"));
          } else {
            nonHiddenCount++;
            nonHiddenWidth += this._percentageToNumber(filter.get("width"));
          }
        }
      }, this);
      //calculate width adjustment for the hidden columns
      let widthAdjustment = 0;
      if (nonHiddenCount > 0) {
        widthAdjustment = hiddenWidth / nonHiddenCount;
      }
      //calculate the scale of the width based on the total width (hidden + nonhidden) being greater than 100%.  If so,
      // scale appropriately.
      let widthScale = 1.0;
      if (hiddenWidth + nonHiddenWidth > 100) {
        widthScale = 100.0 / (nonHiddenWidth + hiddenWidth);
      }
      //return adjusted width
      return (width + widthAdjustment) * widthScale;
    },
    _isPercentage: function (percentageString) {
      return percentageString.endsWith("%");
    },
    _percentageToNumber: function (percentageString) {
      //converts percentage string to number string, or returns 0
      if (this._isPercentage(percentageString)) {
        return parseInt(percentageString.slice(0, -1), 10);
      } else {
        return 0;
      }
    },
  });

  SortableListHeadView.sortableListHeadView = Marionette.CollectionView.extend({
    itemView: SortableListHeadView.sortableListHeadItemView,
    tagName: "tr",
  });

  return SortableListHeadView;
});
